import { MessageType, ActionsClinicInfo, NumberCons } from '../../constants/const';
import {CallPlace, IProducts} from '../http/myActivity.model';
import {DirectionsAndTaxs} from '../http/profile.model';
import { InformationClinics } from '../local/information.clinics.model';
import { ClinicInfoToModal } from '../local/general.model';
import { IPendingOrders } from '../http/pendingOrders';
import { MissingProduct } from '../http/missingProduct.model';
export interface GeneralMessage {
    typeIcon: TypeIcon;
    textToShow: string;
    isButtonCancel?: boolean;
    typeMessage: MessageType;
    wasOk?: boolean;
    itemCode?: string;
    request?: CallPlace;
    product?: IProducts;
    address?: DirectionsAndTaxs;
    clinicInfo?: InformationClinics;
    clinicInfoToModal?: ClinicInfoToModal;
    action?: ActionsClinicInfo;
    pendingOrders?: IPendingOrders;
    missingProduct?: MissingProduct;
    reDirectTo?: string;
    componentId?: string;
    containsInnerHtml?: boolean;
    typeOption?: TypeGeneralResponseOption;
    hideCloseButton?: boolean;
    textAcept?: string;
    textCancel?: string;
}

export enum TypeGeneralResponseOption {
    deleteProductFromDetailOrderListEdit,
    deleteProductFromListShoppingCar,
    deleteDeliveryAddressFromList,
    deleteTaxData,
    deleteDeliveryAddressFromRecipeSettings,
    default
}
export enum TypeDeleteProduct {
    deleteProduct,
    deleteAttribute
}

export class DeleteAttribute {
    productId: number;
    attributeId: number;
    constructor() {
        this.productId = NumberCons.zero;
        this.attributeId = NumberCons.zero;
    }
}
export const enum TypeIcon {
    success,
    question,
    error,
    info,
    scanned,
    assign,
    confirmDelivered,
    delivered,
    notDelivered,
    none,
}
export const TypeIconCompare = {
    success: 0,
    question: 1,
    error: 2,
    info: 3,
    scanned: 4,
    assign: 5,
    confirmDelivered: 6,
    delivered: 7,
    notDelivered: 8,
};
export class NotificationAuthorizeOrder {
    wasOk: boolean;
    isLegacy: boolean;
    pendingOrders: IPendingOrders;
    callPlace: CallPlace;
    constructor(){
        this.wasOk = false;
        this.isLegacy = false;
        this.pendingOrders = new IPendingOrders();
        this.callPlace = CallPlace.default;
    }
}
